export const MDM_SCRIPTS = {
  TITLE: 'Scripts',
  SUBTITLE: 'Configure and run scripts across your organization',
  SEARCH_PLACEHOLDER: 'Search scripts...',
  NEW_SCRIPT: 'New Script',
  RUN: 'Run',
  RUN_SCRIPT: 'Run Script',
  SCRIPT_DETAILS: 'Script Details',
  NO_SCRIPT_CONTENT: 'No script content',
  SECTIONS: {
    RUN_HISTORY: 'Run History',
  },
}

export const MDM_SCRIPTS_TABLE = {
  NAME: 'Name',
  PLATFORM: 'Platform',
  STATUS: 'Status',
  LAST_RUN: 'Last Run',
  RUNS: 'Runs',
  NO_RUNS: 'No runs',
  RUNS_COUNT: (count: number) => `${count} runs`,
}

export const MDM_SCRIPTS_SUMMARY = {
  RUNS: 'Runs',
  SUCCESSFUL: 'Successful',
  FAILED: 'Failed',
}

export const MDM_SCRIPTS_STATUS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  NOT_RUN: 'Not run',
}

export const MDM_SCRIPTS_PLATFORMS = {
  MACOS: 'macOS',
  WINDOWS: 'Windows',
  LINUX: 'Linux',
  ALL_PLATFORMS: 'All platforms',
}

export const MDM_SCRIPTS_RUN_STATUS_BAR = {
  HOSTS_SUCCEEDED: 'hosts succeeded',
  HOSTS_FAILED: 'hosts failed',
}

export const MDM_SCRIPTS_RUN_DIALOG = {
  RUN_PREFIX: 'Run',
  DESCRIPTION_COMPLETE: 'Script has been queued for execution.',
  DESCRIPTION_SELECT: 'Review the script and select the groups to run it on.',
  SEARCH_GROUPS: 'Search groups...',
  DONE: 'Done',
  CANCEL: 'Cancel',
  RUNNING: 'Running...',
  QUEUED: 'Queued',
}

export const MDM_SCRIPTS_DRAWER = {
  PLATFORM: 'Platform',
  CODE: 'Code',
  RUN_HISTORY: 'Run History',
  RUN_HISTORY_COUNT: (count: number) => `Run History (${count})`,
  HOSTS: 'Hosts',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  NO_RUNS: 'No runs',
  LOADING_HOST_RESULTS: 'Loading host results...',
  REFRESH: 'Refresh',
  PENDING_HINT: 'Hosts run it at their next check-in, which can take a while',
}

export const MDM_SCRIPTS_RUN_ITEM = {
  RUN_PREFIX: 'Run #',
  HOSTS: 'Hosts',
  SUCCEEDED: 'Succeeded',
  ERRORS: 'Errors',
  HOST_RESULTS: 'Host Results',
  SUCCESS: 'Success',
  ERROR: 'Error',
  PENDING: 'Pending',
  CANCELED: 'Canceled',
  INCOMPATIBLE: 'Incompatible',
  RAN: 'Ran',
  EXECUTION_OUTPUT: 'Execution Output',
  EXIT_CODE: 'Exit Code',
  RUNTIME: 'Runtime',
  SECONDS: 'seconds',
  OUTPUT: 'Output',
  NO_OUTPUT: 'No output available',
  LOADING_OUTPUT: 'Loading execution output...',
  HOST_TIMEOUT: 'Host timed out',
  SCRIPT_REMOVED: 'Script removed',
}

export const MDM_SCRIPTS_FORM = {
  NAME: 'Name',
  ENTER_SCRIPT_NAME: 'Enter script name',
  PLATFORM: 'Platform',
  SCRIPT_CONTENT: 'Script Content',
  ENTER_SCRIPT_CONTENT: 'Enter script content',
  CREATE_SCRIPT: 'Create Script',
  CANCEL: 'Cancel',
}

export const MDM_SCRIPTS_MESSAGES = {
  CREATED: 'Script created successfully',
  FAILED_TO_CREATE: 'Failed to create script',
  DELETED: 'Script deleted successfully',
  FAILED_TO_DELETE: 'Failed to delete script',
  NAME_CONFLICT: (name: string) => `A script named "${name}" already exists, please choose another name.`,
}

export const MDM_SCRIPTS_DELETE_DIALOG = {
  TITLE: 'Delete Script',
  DESCRIPTION_PREFIX: 'Are you sure you want to delete',
  DESCRIPTION_SUFFIX: '? This action cannot be undone.',
  CANCEL: 'Cancel',
  CONFIRM: 'Delete',
}
